import { render, staticRenderFns } from "./CardProduct.vue?vue&type=template&id=29345104&scoped=true"
import script from "./CardProduct.js?vue&type=script&lang=js&external"
export * from "./CardProduct.js?vue&type=script&lang=js&external"
import style0 from "./CardProduct.scss?vue&type=style&index=0&id=29345104&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29345104",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default})
